import React, { useEffect, useState } from 'react';
import { Route, createBrowserRouter, createRoutesFromElements, Outlet, RouterProvider, BrowserRouter } from 'react-router-dom';
import Header from './Components/Layout/Header';
import HeaderAR from './Components/Layout/HeaderAR';
import Footer from './Components/Layout/Footer';
import FooterAR from './Components/Layout/FooterAR';
import AppRoute from './Components/Variables/AppRoute';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import './OssaKbire.css';
import { useTranslation } from 'react-i18next';
import './i18n';

function App(props) {
  const [subscribe, setSubscribe] = useState(false)
  const { i18n } = useTranslation();
  document.body.dir = i18n.dir();
  // const router = createBrowserRouter(
  //   createRoutesFromElements(
  //     a == "ar" ? (



  //       <Route path="/" element={<RootAR language={language} setLanguage={setLanguage} />}>
  //         <Route index element={<HomeAR />} />
  //         <Route path="/Contact" element={<ContactAR />} />
  //         <Route path="/Authentication" element={<Authentication />} />
  //         <Route path="/Shop" element={<ShopAR />} />
  //         <Route path="/Checkout" element={<CheckoutAR />} />
  //       </Route>


  //     ) : (

  //       <Route path="/" element={<Root language={language} setLanguage={setLanguage} />}>
  //         <Route index element={<Home />} />
  //         <Route path="/Contact" element={<Contact />} />
  //         <Route path="/Authentication" element={<Authentication />} />
  //         <Route path="/Shop" element={<Shop />} />
  //         <Route path="/Checkout" element={<Checkout />} />
  //       </Route>

  //     )

  //   )
  // )
  // const router = createBrowserRouter(
  //   createRoutesFromElements(
  //       <Route path="/" element={<Root language={language} setLanguage={setLanguage} />}>
  //         <Route index element={<Home />} />
  //         <Route path="/Contact" element={<Contact />} />
  //         <Route path="/Authentication" element={<Authentication />} />
  //         <Route path="/Shop" element={<Shop />} />
  //         <Route path="/Checkout" element={<Checkout />} />


  //         <Route path="/AR" element={<HomeAR />} />
  //         <Route path="/AR/Contact" element={<ContactAR />} />
  //         <Route path="/Authentication" element={<Authentication />} />
  //         <Route path="/Shop" element={<ShopAR />} />
  //         <Route path="/Checkout" element={<CheckoutAR />} />

  //       </Route>


  //   )
  // )

  return (
    <>
      <div>
        <BrowserRouter>
          <AppRoute
          setSubscribe={setSubscribe}
          />
          {/* <RouterProvider router={router} /> */}
          <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </BrowserRouter>

      </div>
    </>
  );
}

export default App;

const Root = (props) => {

  return (
    <>
      <Header />
      <div>
        <Outlet />
      </div>
      <Footer />
    </>
  )
}

